import styled from 'styled-components';

export const MenusWrap = styled.li`
  display: inline-block;
  box-sizing: border-box;
  outline: none;
  position: relative;

  > a, 
  > p {
    display: block;
    height: 60px;
    padding: 0 15px;
    color: #FFF;
    font-size: 12px;
    line-height: 60px;
    outline: none;
    cursor: pointer;

    > svg {
      fill: #fff;
      margin-left: 10px;
    }
  }

  @media screen and (min-width: 1400px) {
    height: 60px;
    text-align: left;
    
    ${props => props.isActive && `
      border-bottom: 3px solid #61DAFB;
      box-sizing: border-box;

      > p,
      > a {
        color: #61DAFB;
      }
    `}

    &:hover {
      > ul {
        display: block;
      }

      > a,
      > p {
        color: #61DAFB;
      }
    }
    
    > p,
    > a {
      color: #fff;

      &:hover {
        color: #61DAFB;

        > svg {
          fill: #61DAFB;
        }
      }
    }

    &.LogoutBtn {
      display: none;
    }
  }

  @media screen and (max-width: 1399px) {
    display: block;
    text-align: center;

    ${props => props.isActive && `
      > p,
      > a {
        color: #61DAFB;
      }
    `}
  }
`

export const Dropdown = styled.ul`
  display: none;
  padding: 0;
  list-style: none;

  > li {
    white-space: pre;

    > a {
      display: block;
      padding: 0 25px;
      font-size: 12px;
      line-height: 40px;
      cursor: pointer;
    }
  }

  @media screen and (min-width: 1400px) {
    background-color: #FFF;
    box-shadow: 0 1px 7px 0px rgba(0,0,0,0.5);
    position: absolute;
    right: 0;
    
    > li > a:hover {
      color: #61DAFB;
      background-color: #20232a;
    }
  }

  @media screen and (max-width: 1399px) {
    display: block;
    height: ${props => props.isOpen ? `${props.length * 40 + 22}px` : '0px'};
    padding: ${props => props.isOpen ? '10px' : 0};
    text-align: center;
    ${props => props.isOpen && `
      border-top: 1px solid #61DAFB;
      border-bottom: 1px solid #61DAFB;
    `}
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease-in;

    > li {
      background-color: #FFF;

      > a:hover {
        background-color: #61DAFB;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./client/components/Header/MenuComponent/styled.js